import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import ActionMenu from '../../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../../components/ActionMenu/ActionMenuItem';
import { FormConfig } from '../../../components/Fields/Types';
import UserDefinedField from '../../../components/Fields/UserDefinedField';
import useSelectListOptions from '../../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import useValidation from '../../../components/Hooks/ValidationHook/useValidation';
import { ApplicationFunctions, useAuth } from '../../../contexts/authContext';
import { useNotifications } from '../../../contexts/notificationContext';
import AssociationTypes from '../../../enums/AssociationTypes';
import BillOfMaterialModel from '../../../models/BillOfMaterialModel';
import UserDefinedFieldModel from '../../../models/UserDefinedFieldModel';
import UserDefinedFieldValueModel from '../../../models/UserDefinedFieldValueModel';
import DataService from '../../../services/data.service';
import { PagingDetails } from '../ItemAdvanced';
import Button from './../../../components/Buttons/Button';
import ButtonBar from './../../../components/Fields/ButtonBar';
import Form from './../../../components/Fields/Form';
import MultiSelectField from './../../../components/Fields/MultiSelectField';
import SelectListField from './../../../components/Fields/SelectListField';
import SwitchField from './../../../components/Fields/SwitchField';
import TextboxField from './../../../components/Fields/TextboxField';
import Item_popup_CreateItem from './../Popups/Item_popup_CreateItem';

export interface ItemFilterFormProps {
    pagingDetails?: PagingDetails
    handleSearch: (criteria: ItemSearchCriteria) => void
    handleAddToProject?: () => void
    handleDeleteItems?: () => void
    handleSalesPresentation?: () => void
    handleSelectAll?: () => void
    handleClearSelection?: () => void
    forBom: boolean
    bom?: BillOfMaterialModel
    projectId?: number
    projectTypeId?: number
    productCategoryId?: number
}

export interface ItemSearchCriteria {
    quickSearch: string
    itemTypeIds: number[]
    brandId?: number
    productCategoryId?: number
    projectTypeId?: number
    employeeIds: number[]
    projectIds: number[]
    supplier_BusinessPartnerId?: number
    customer_BusinessPartnerId?: number
    licensor_BusinessPartnerId?: number
    itemStatusTypeId?: number
    itemStatusIds: number[]
    designPhases: number[]
    divisionIds: number[]
    includeUnsearchableItems: boolean
    searchInBomItems: boolean
    activeOnly: boolean
    mainItemsOnly: boolean
    fromNavBar: boolean
    rememberFilter: boolean
    userDefinedFields: UserDefinedFieldValueModel[]

    pageNumber: number
    pageSize: number
    sortBy: string
}

const ItemFilterFormAdvanced: React.FC<ItemFilterFormProps> = ({ pagingDetails, handleSearch, handleAddToProject, handleDeleteItems, handleSalesPresentation, handleSelectAll, handleClearSelection, projectId, projectTypeId, productCategoryId, forBom, bom }) => {
    const [formData, setFormData] = useState<ItemSearchCriteria>()
    const [itemTypeId, setItemTypeId] = useState(0)
    const [userDefinedFields, setUserDefinedFields] = useState<UserDefinedFieldModel[]>([])
    const [showFilter, setShowFilter] = useState<boolean>(true);
    const [showCreateItemPopup, setShowCreateItemPopup] = useState<boolean>(false);
    const { handleResult, handleException } = useNotifications();
    const [criteriaStorageName] = useState(forBom ? "itemFilterFormAdvancedForBom" : "itemFilterFormAdvanced")

    let includeUnsearchableItems = false
    if (projectTypeId)
        includeUnsearchableItems = true

    var itemTypesUrl = `api/v1/selectlist/ItemTypes?activeOnly=${formData?.activeOnly ?? true}&applicationFunctionId=${ApplicationFunctions.SearchItemRevisionAdvanced}`;
    if (projectTypeId)
        itemTypesUrl = `api/v1/selectlist/ItemTypes?activeOnly=${formData?.activeOnly}&projectTypeId=${projectTypeId}&applicationFunctionId=${ApplicationFunctions.SearchItemRevisionAdvanced}`;
    if (forBom == true)
        itemTypesUrl = 'api/v1/selectlist/ItemTypesForBom'

    const itemTypes = useSelectListOptions(itemTypesUrl);
    const brands = useSelectListOptions(`api/v1/selectlist/BrandNameTrees?activeOnly=${formData?.activeOnly ?? true}`, '-- All brands');
    const productCategories = useSelectListOptions(`api/v1/selectlist/ProductCategoryNameTrees?activeOnly=${formData?.activeOnly ?? true}&itemTypeId=${itemTypeId}`, '-- All productcategories');
    const customers = useSelectListOptions(`api/v1/selectlist/businessPartners?activeOnly=${formData?.activeOnly ?? true}&businessPartnerTypeId=1`, '-- All customers')
    const suppliers = useSelectListOptions(`api/v1/selectlist/businessPartners?activeOnly=${formData?.activeOnly ?? true}&businessPartnerTypeId=2`, '-- All suppliers')
    const licensors = useSelectListOptions(`api/v1/selectlist/businessPartners?activeOnly=${formData?.activeOnly ?? true}&businessPartnerTypeId=3`, '-- All licensors')
    const projects = useSelectListOptions('api/v1/selectlist/projects?activeOnly=' + formData?.activeOnly ?? true)
    const employees = useSelectListOptions('api/v1/selectlist/employees?activeOnly=' + formData?.activeOnly ?? true)
    const statuses = useSelectListOptions('api/v1/selectlist/itemStatuses?activeOnly=' + formData?.activeOnly ?? true)
    const designPhases = useSelectListOptions('api/v1/selectlist/designphases?activeOnly=' + formData?.activeOnly ?? true)
    const divisions = useSelectListOptions('api/v1/selectlist/divisions?activeOnly=' + formData?.activeOnly ?? true)

    useEffect(() => {
        const filterItem = localStorage.getItem(criteriaStorageName);
        if (filterItem !== null) {
            let filter: ItemSearchCriteria = JSON.parse(filterItem);

            const fromNavBar = filter.fromNavBar;

            filter.fromNavBar = false;

            setFormData({ ...filter });

            if (filter.rememberFilter)
                localStorage.setItem(criteriaStorageName, JSON.stringify(filter));
            else
                localStorage.removeItem(criteriaStorageName);

            if (fromNavBar)
                handleSearch(filter);
        }
        else
        {
            setDefaultCriteria();
        }
    }, [])

    useEffect(() => {
        if (formData)
            setItemTypeId(formData.itemTypeIds[0])
        else
            setItemTypeId(0)
    }, [formData?.itemTypeIds])

    useEffect(() => {
        if (formData) {
            formData.productCategoryId = 0
            setFormData(formData)
            getUdfs()
        }

        function getUdfs() {
            DataService.get<UserDefinedFieldModel[]>('api/v1/UserDefinedFields/Searchable/' + itemTypeId)
                .then(response => {
                    console.log('UserDefinedFields:', response)
                    setUserDefinedFields(response);

                    if (formData) {
                        formData.userDefinedFields = []
                        response.forEach((field) => {

                            let options = field.options ?? []
                            options.unshift({ value: '', label: '-- Select ' + field.name })

                            formData.userDefinedFields.push({
                                id: 0,
                                userDefinedFieldId: field.id,
                                userDefinedField: field,
                                options: options,
                                value: '',
                                concurrencyId: ''
                            })

                        })
                        console.log(formData)
                        setFormData(x => ({ ...formData }))
                    }

                })
                .catch(e => { handleException(e); });
        }

    }, [itemTypeId])

    useEffect(() => {
        if (formData && pagingDetails)
        {
            const doSearch = formData.pageNumber != pagingDetails.pageNumber

            formData.pageSize = pagingDetails.pageSize
            formData.pageNumber = pagingDetails.pageNumber
            formData.sortBy = pagingDetails.sortBy

            setFormData(() => formData)

            if (pagingDetails.pageNumber > 1 && doSearch === true)
                handleSearch(formData)
        }
    }, [pagingDetails])

    function setDefaultCriteria() {
        let defaultCriteria: ItemSearchCriteria = {
            quickSearch: '',
            itemTypeIds: [],
            brandId: 0,
            productCategoryId: productCategoryId,
            projectTypeId: projectTypeId,
            employeeIds: [],
            projectIds: [],
            itemStatusIds: [],
            designPhases: [],
            divisionIds: [],
            includeUnsearchableItems: includeUnsearchableItems,
            searchInBomItems: false,
            activeOnly: true,
            mainItemsOnly: true,
            fromNavBar: false,
            rememberFilter: formData?.rememberFilter ?? false,
            userDefinedFields: [],

            pageNumber: 1,
            pageSize: 100,
            sortBy: 'CreatedOn'
        }
        if (userDefinedFields)
            userDefinedFields.forEach((field) => {
                let options = field.options ?? []
                options.unshift({ value: '', label: '-- Select ' + field.name })

                defaultCriteria.userDefinedFields.push({
                    id: 0,
                    userDefinedFieldId: field.id,
                    userDefinedField: field,
                    options: options,
                    value: '',
                    concurrencyId: ''
                })
            })

        setFormData({ ...defaultCriteria })
    }

    function search() {
        if (formData) {
            setShowFilter(false);

            formData.pageNumber = 1
            setFormData(() => formData)

            if (formData.rememberFilter)
                localStorage.setItem(criteriaStorageName, JSON.stringify(formData));
            else
                localStorage.removeItem(criteriaStorageName);

            handleSearch(formData);
        }
    }


    const formConfig: FormConfig = {
        fields: [
            { name: 'quickSearch', label: 'Search', labelSize: 3 },
            { name: 'itemTypeIds', label: 'Item types', labelSize: 3 },
            { name: 'brandId', label: 'Brand', labelSize: 3 },
            { name: 'productCategoryId', label: 'Product category', labelSize: 3 },
            { name: 'supplier_BusinessPartnerId', label: 'Supplier', labelSize: 3 },
            { name: 'customer_BusinessPartnerId', label: 'Customer', labelSize: 3 },
            { name: 'licensor_BusinessPartnerId', label: 'Licensor', labelSize: 3 },
            { name: 'projectIds', label: 'Project', labelSize: 3 },
            { name: 'employeeIds', label: 'Employee', labelSize: 3 },
            { name: 'itemStatusIds', label: 'Status', labelSize: 3 },
            { name: 'designPhases', label: 'Design phase', labelSize: 3 },
            { name: 'divisionIds', label: 'Division', labelSize: 3 },
            { name: 'searchInBomItems', label: 'Search in bill-of-materials', labelSize: 3 },
            { name: 'activeOnly', label: 'Search for active items only', labelSize: 3 },
            { name: 'mainItemsOnly', label: 'Search for main items only', labelSize: 3 },
            { name: 'rememberFilter', label: 'Remember search criteria', labelSize: 3 },

        ],
        handleSubmit: search,
        showErrors: 'always',
    };


    //console.log('udfs', userDefinedFields)
    //console.log('formData', formData)
    if (userDefinedFields) {
        userDefinedFields.forEach((value, index) => {
            let label = value.name;
            formConfig.fields.push({ name: 'userDefinedFields.' + index + '.value', label: label, labelSize: 3 });
        });
    }

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData);
    const { isAuthorizedForItemType, isAuthorizedFor } = useAuth();

    const formActions = !isAuthorizedForItemType(ApplicationFunctions.CreateItem)
        ? undefined
        : <ActionMenu title="Actions">
            <ActionMenuItem icon="fa fa-plus" iconVariant="success" title="Create new item" onClick={() => { setShowCreateItemPopup(true); }} appFunction={ApplicationFunctions.CreateItem} itemTypeId={0} />
          </ActionMenu>

    return (
        <>
            {formData && showFilter && (
                <Form title='Search itemrevisons' actions={formActions} footer={(
                    <ButtonBar offset={2}>
                        <Button text='Search' {...getSubmitButtonProps()} />
                        <Button text='Clear criteria' type='button' onClick={setDefaultCriteria} />
                    </ButtonBar>
                )}>
                    <Container fluid>
                        <Row>
                            <Col md='6'>
                                <TextboxField {...getFieldProps('quickSearch')} />
                                <MultiSelectField {...getFieldProps('itemTypeIds')} options={itemTypes} />
                                <SelectListField {...getFieldProps('brandId')} options={brands} />
                                <SelectListField {...getFieldProps('productCategoryId')} options={productCategories} />
                                <SelectListField {...getFieldProps('supplier_BusinessPartnerId')} options={suppliers} />
                                <SelectListField {...getFieldProps('customer_BusinessPartnerId')} options={customers} />
                                <SelectListField {...getFieldProps('licensor_BusinessPartnerId')} options={licensors} />
                                {formData.userDefinedFields && userDefinedFields.length > 0 && (
                                    formData.userDefinedFields.map((udf: UserDefinedFieldValueModel, index: number) => {
                                        return <UserDefinedField
                                            {...getFieldProps(`userDefinedFields.${index}.value`)}
                                            userDefinedFieldValue={udf}
                                            visible={true}
                                            key={`udf.${index}`}
                                        />
                                    })
                                )}

                            </Col>
                            <Col md='6'>
                                <MultiSelectField {...getFieldProps('projectIds')} options={projects} />
                                <MultiSelectField {...getFieldProps('employeeIds')} options={employees} />
                                <MultiSelectField {...getFieldProps('itemStatusIds')} options={statuses} />
                                <MultiSelectField {...getFieldProps('designPhases')} options={designPhases} />
                                <MultiSelectField {...getFieldProps('divisionIds')} options={divisions} />
                                <SwitchField {...getFieldProps('searchInBomItems')} />
                                <SwitchField {...getFieldProps('activeOnly')} />
                                <SwitchField {...getFieldProps('mainItemsOnly')} />
                                <SwitchField {...getFieldProps('rememberFilter')} />
                            </Col>
                        </Row>

                    </Container>
                </Form>
            )}
            {!showFilter && (
                <ButtonBar offset={0}>
                    <Button text='Show filter' onClick={() => setShowFilter(true)} />
                    {handleDeleteItems && isAuthorizedFor(ApplicationFunctions.DeleteItemRevision) && <Button text='Delete selected itemrevisions' onClick={() => handleDeleteItems()} />}
                    {handleAddToProject && <Button text='Add to project' onClick={() => handleAddToProject()} />}
                    {handleSalesPresentation && <Button text='Sales presentation' onClick={() => handleSalesPresentation()} />}
                    {handleSelectAll && <Button text='Select all items' onClick={() => handleSelectAll()} />}
                    {handleClearSelection && <Button text='Clear selection' onClick={() => handleClearSelection()} />}
                </ButtonBar>
            )}
            <Item_popup_CreateItem projectId={projectId} projectTypeId={projectTypeId} show={showCreateItemPopup} onHide={() => setShowCreateItemPopup(false)} />
        </>
    );
}
export default ItemFilterFormAdvanced;